import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import styled, { css } from 'styled-components/macro';
import ContentLoader from 'react-content-loader';
import Text, { TextVariant } from '../Text/Text';
import { ReactComponent as HeartIcon } from './red-heart.svg';
import { ReactComponent as HeartActiveIcon } from './red-heart-filled.svg';
export var LikeButtonColorVariant;
(function (LikeButtonColorVariant) {
    LikeButtonColorVariant["Default"] = "Default";
    LikeButtonColorVariant["Transparent"] = "Transparent";
    LikeButtonColorVariant["Pearl"] = "pearl";
})(LikeButtonColorVariant || (LikeButtonColorVariant = {}));
const Wrapper = styled.button `
  padding: 0;
  border: none;
  border-radius: 32px;
  opacity: 0.9;
  display: flex;
  justify-content: center;
  align-items: center;

  ${props => props.colorVariant === LikeButtonColorVariant.Default &&
    `background-color: ${props.theme.color.snow};`}

  ${props => props.colorVariant === LikeButtonColorVariant.Pearl &&
    `background-color: ${props.theme.color.pearl};`}

  min-width: 36px;
  height: 36px;

  @media ${props => props.theme.device.tabletL} {
    width: auto;
    ${props => props.hasLabel && `padding: 15px;`};
  }

  &:hover {
    cursor: pointer;
    border: 1px solid ${props => props.theme.color.stone};
  }
`;
const IconWrap = styled.div `
  width: 24px;
  height: 24px;

  ${props => props.hovered &&
    css `
      width: 22px;
      height: 22px;
    `};

  display: flex;
  justify-content: center;
  align-items: center;
`;
const ButtonLabel = styled(Text) `
  display: none;
  @media ${props => props.theme.device.tabletL} {
    display: initial;
    padding: 5px;
  }
`;
const LikeButton = ({ dataTestId, liked, onClick, colorVariant = LikeButtonColorVariant.Default, loading = false, label, }) => {
    const [heartHovered, setHeartHovered] = useState(false);
    if (loading) {
        return (_jsx(Wrapper, Object.assign({ onPointerEnter: () => setHeartHovered(true), onPointerLeave: () => setHeartHovered(false), colorVariant: colorVariant }, { children: _jsxs(ContentLoader, Object.assign({ speed: 0.9, height: "24", width: "24", viewBox: "0 0 24 24", backgroundColor: "#EA786F", foregroundColor: "#E13F32" }, { children: [_jsx("mask", Object.assign({ id: "a", fill: "#fff" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m18.551 14.145-6.55 6.74-3.758-3.865-2.794-2.874-1.092-1.124c-1.81-1.861-1.81-4.879 0-6.74a4.541 4.541 0 0 1 6.551 0L12 7.405l1.092-1.123a4.541 4.541 0 0 1 6.551 0c1.81 1.86 1.81 4.879 0 6.74l-1.092 1.123Z" }) })), _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m18.551 14.145-6.55 6.74-3.758-3.865-2.794-2.874-1.092-1.124c-1.81-1.861-1.81-4.879 0-6.74a4.541 4.541 0 0 1 6.551 0L12 7.405l1.092-1.123a4.541 4.541 0 0 1 6.551 0c1.81 1.86 1.81 4.879 0 6.74l-1.092 1.123Z", fill: "#E13F32" }), _jsx("path", { d: "m18.551 14.146.718.697.677-.698-.678-.697-.717.698Zm0 0-.717-.698-.677.697.677.697.717-.697Zm-6.55 6.74-.718.697.717.737.717-.737-.717-.697ZM8.242 17.02l.717-.697-.717.697ZM5.45 14.146l-.717.697.717-.697Zm-1.092-1.124.717-.697-.717.697Zm0-6.74-.717-.697.717.697Zm6.551 0-.717.697.717-.697ZM12 7.405l-.717.697.717.738.717-.738L12 7.405Zm1.092-1.123.717.697-.717-.697Zm6.551 0 .717-.697-.717.697Zm0 6.74.717.697-.717-.697Zm-.375.426-1.434 1.394 1.434-1.394Zm-6.55 8.135 6.55-6.74-1.434-1.394-6.551 6.74 1.434 1.394Zm-5.192-3.866 3.757 3.866 1.434-1.394-3.757-3.866-1.434 1.394Zm-2.794-2.874 2.794 2.874 1.434-1.394-2.794-2.874-1.434 1.394ZM3.64 13.719l1.092 1.124 1.434-1.394-1.092-1.124L3.64 13.72Zm0-8.134c-2.186 2.25-2.186 5.885 0 8.134l1.434-1.394c-1.432-1.473-1.432-3.873 0-5.346L3.64 5.585Zm7.985 0a5.541 5.541 0 0 0-7.985 0L5.074 6.98a3.541 3.541 0 0 1 5.117 0l1.434-1.394Zm1.092 1.123-1.092-1.123-1.434 1.394 1.092 1.123 1.434-1.394Zm0 1.394 1.092-1.123-1.434-1.394-1.092 1.123 1.434 1.394Zm1.092-1.123a3.541 3.541 0 0 1 5.117 0l1.434-1.394a5.541 5.541 0 0 0-7.985 0l1.434 1.394Zm5.117 0c1.432 1.473 1.432 3.873 0 5.346l1.434 1.394c2.187-2.25 2.187-5.885 0-8.134l-1.434 1.394Zm0 5.346-1.092 1.123 1.434 1.394 1.092-1.123-1.434-1.394Z", fill: "#E13F32", mask: "url(#a)" })] })) })));
    }
    let heart = _jsx(HeartIcon, {});
    if (liked) {
        heart = _jsx(HeartActiveIcon, {});
    }
    return (_jsxs(Wrapper, Object.assign({ "data-testid": dataTestId, onPointerEnter: () => setHeartHovered(true), onPointerLeave: () => setHeartHovered(false), onClick: () => onClick(!liked), colorVariant: colorVariant, hasLabel: !!label }, { children: [_jsx(IconWrap, Object.assign({ hovered: heartHovered }, { children: heart })), label && _jsx(ButtonLabel, Object.assign({ variant: TextVariant.B40 }, { children: label }))] })));
};
export default LikeButton;
